
/*
    Form for creating a new lane change or editing an existing one

    match one lane to the reassigned lane and when the change is in effect
*/

import React, { createRef } from "react";

import MainContext from "../MainContext";

import DateInput from "../Components/DateInput";

import TimeInput from "../Components/TimeInput";

import { getLanes, getRoutes } from "../Requests/UtilityRequests";

import { scrollToRef } from "../Scripts/Utilities";
import { ThemeProvider } from "react-bootstrap";
// import { addLaneChange } from "../Requests/MessageRequests";

function translateTime(propDateTime){
    const timeSplit = propDateTime.split(" ");
    // return propTime[0] + propTime[1] + ":" + propTime[2] + propTime[3];
    // just skip the date
    return timeSplit[1] + " " + timeSplit[2];
}

function getCurrentTime(){
    const d = new Date();

    const hours = d.getHours();
    let minutes = d.getMinutes();
    const isPM = hours >= 12;

    console.log("hours", hours, isPM);

    let hoursToUse = (hours > 12) ? (hours - 12) : (hours === 0) ? "12" : hours; 

    if(hoursToUse < 10){
        hoursToUse = "0" + hoursToUse;
    }
    
    if(minutes < 10) {
        minutes = "0" + minutes;
    }

    return `${hoursToUse}:${minutes} ${isPM ? 'PM': 'AM'}`;
}

function createFullDate(date, time){
    console.log("CREATE FULL DATE INPUTS", date, time);

    let datestring = `${date} ${time}`;

    if(typeof date !== "string"){
        datestring = `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()} ${time}`;
    }

    const full = new Date(datestring);
    console.log("CREATE FULL DATE", datestring, full);
    return full;
}

const defaultState = {
    originalLane: -1,
    newLane: -1,
    routes: [],
    routeSelected: -1,
    lanes: [],
    startDate: new Date(),
    startTime: getCurrentTime(),
    endDate: new Date(),
    endTime: getCurrentTime(),
    allLanes: [],
    allLocationLanes: [],
    isEdit: false,
    errors: []
};

export default class LaneChangeForm extends React.Component {

    static contextType = MainContext;

    constructor(){ 
        super();

        this.state = defaultState;

        this.focusRef = createRef();
    }

    locationToUse = () => {
        if(this.props.location && this.props.location != -1){
            return this.props.location;
        }
        return this.props.data.location_id;
    }

    updateValue = (evt) => {
        this.setState({[evt.target.name]:evt.target.value});
    }

    routeUpdate = (evt) => {
        this.updateValue(evt);
        this.updateLanes(evt.target.value);
    }

    updateLanes = (route) => {

        const params = {
            location: this.locationToUse()
        };

        console.log("ROUTE CHANGED", route);

        if(route && route != -1){
            params.route = route;
        }

        const request = () => getLanes(params);
        const then = ({data}) => {
            const cleaned = data.map(v => v.laneGate);
            this.setState({lanes: cleaned});

            if(!route && this.state.allLocationLanes.length === 0){
                this.setState({allLocationLanes: cleaned});
            }

            scrollToRef(this.focusRef.current);

            return;
            //
            // set the state if we're passed in existing values
            //
            if(this.props.data && this.props.data.original_value){
                /*
                    from_date: "19-SEP-20"
                    from_time: "0930"
                    new_value: "314"
                    original_value: "315"
                    terminal: "PABT"
                    to_date: "19-DEC-20"
                    to_time: "1030"
                    type: "Gate Change"
                */
                this.setState({
                    originalLane: this.props.data.original_value,
                    newLane: this.props.data.new_value,
                    startDate: this.props.data.from_date,
                    startTime: translateTime(this.props.data.from_time),
                    endDate: this.props.data.to_date,
                    endTime: translateTime(this.props.data.to_time)
                });
            }
        };
        this.context.runProcessing(request, then, "getLanes");
    }

    getAllRoutes = (location, useExisting) => {
        console.log("GET ROUTES", location);

        const request = () => getRoutes(location);
        const then = ({data}) => {
            console.log("ROUTES RETURNED", data);
            const cleaned = data.map(v => v.Route);
            this.setState({routes: cleaned}, () => {
                //
                // set the state if we're passed in existing values
                //
                if(useExisting && this.props.data){
                    console.log("USE EXISTING", this.props.data, this.state.routes);
                    /*
                    string location_id
                    string route
                    string current_gate
                    string new_gate
                    string start_date  			//date format : "DD-MON-YY HH:MI AM"
                    string end_date
                */
                    this.setState({
                        originalLane: this.props.data.current_gate,
                        routeSelected: this.props.data.route,
                        newLane: this.props.data.new_gate,
                        startDate: this.props.data.start_date,
                        startTime: this.props.data.start_time + " " + this.props.data.start_time_suffix,
                        endDate: this.props.data.end_date,
                        endTime: this.props.data.end_time + " " + this.props.data.end_time_suffix
                    });
                }
            });

            scrollToRef(this.focusRef.current);
        };
        this.context.runProcessing(request, then, "getRoutes");
    }

    componentDidMount(){
        console.log("LANE CHANGE FORM PROPS", this.props);

        this.setState({isEdit: this.props.isEdit});

        this.getAllRoutes(this.locationToUse(), true);
        this.updateLanes();

        /*
            originalLane: -1,
            newLane: -1,
            routes: [],
            routeSelected: -1,
            lanes: [],
            startDate: new Date(),
            startTime: getCurrentTime(),
            endDate: new Date(),
            endTime: getCurrentTime(),
        */
    }

    componentDidUpdate(prevProps, prevState){
        if(prevProps.location !== this.props.location){
            this.setState(defaultState, () => {
                this.getAllRoutes(this.props.location);
            });
        }
    }

    submitLaneChange = () => {
        if(this.runCheck()){
            const startDate = createFullDate(this.state.startDate, this.state.startTime);
            const endDate = createFullDate(this.state.endDate, this.state.endTime);

            console.log("START AND END", startDate, endDate);

            this.props.onSubmit({startDate, endDate, ...this.state}, this.props.index);
        }
    }

    runCheck = () => {
        // must have a value for either old lane or route
        // must have a value for new lane
        // new lane and old lane can't have the same value
        // start and end times must be different
        // end datetime must be in the future

        const errors = [];

        const fullStart = createFullDate(this.state.startDate, this.state.startTime);
        const fullEnd = createFullDate(this.state.endDate, this.state.endTime);

        console.log("THE RETURNED TIME?", this.state.startDate, this.state.startTime);
        console.log("THE RETURNED TIME?", this.state.endDate, this.state.endTime);

        if(this.state.routeSelected == -1 && this.state.originalLane == -1){
            console.log("ROUTE AND ORIGINAL", this.state.routeSelected, this.state.originalLane);
            errors.push("* Must have a value for at least one of Route or Original lane/gate");
        }

        if(this.state.newLane == -1){
            errors.push("* New lane/gate must have a value");
        }
        else if(this.state.newLane === this.state.originalLane){
            errors.push("* New and Original lane/gates must be different");
        }

        if(fullEnd - fullStart < 0){
            errors.push("* End point must be after Start");
        }
        else if(fullEnd - fullStart == 0){
            errors.push("* Start and End must be different");
        }

        console.log("ERRORS", errors);

        this.setState({errors});

        return errors.length === 0;
    }

    render(){
        return (
            <div>
                {
                    !this.props.location || this.props.location == -1
                    ? <div style={{paddingLeft: "11px", paddingBottom: "3px"}}>Location: {this.locationToUse()}</div>
                    : <></>
                }
                <div className="form-element-horizontal">
                    <label>Route</label>
                    <select className="medium-input" ref={this.focusRef} name="routeSelected" value={this.state.routeSelected} onChange={this.routeUpdate}>
                        <option value="-1">Select</option>
                    {
                        this.state.routes.map((r, index) => {
                            return <option key={index} value={r}>{r}</option>
                        })
                    }
                    </select>
                </div>
                <div className="form-element-horizontal">
                    <label>Original Lane</label>
                    <select className="medium-input" ref={this.focusRef} name="originalLane" value={this.state.originalLane} onChange={this.updateValue}>
                    {
                        this.state.lanes.length
                        ? <option value="-1">Select</option>
                        : null
                    }
                    {
                        this.state.lanes.map((lane, index) => {
                            return <option key={index} value={lane}>{lane}</option>
                        })
                    }
                    </select>
                </div>
                <div className="form-element-horizontal">
                <label>New Lane</label>
                    <select className="medium-input" name="newLane" value={this.state.newLane} onChange={this.updateValue}>
                    {
                        this.state.allLocationLanes.length
                        ? <option value="-1">Select</option>
                        : null
                    }
                    {
                        this.state.allLocationLanes.filter(lane => {
                            console.log("CHANGE LANE FILTER CHECK", lane, this.state.Lane)
                            return lane !== this.state.originalLane;
                        }).map((lane, index) => {
                            return <option key={index} value={lane}>{lane}</option>
                        })
                    }
                    </select>
                </div>
                <div className="form-element-horizontal">
                    <label>Start Date</label>
                    <DateInput 
                        name="startDate"
                        value={this.state.startDate} 
                        onChange={this.updateValue} 
                    />
                </div>
                <div className="form-element-horizontal">
                    <label>Start Time</label>
                    <TimeInput name="startTime" value={this.state.startTime} onChange={this.updateValue} nonMilitary={true} />                    
                </div>
                <div className="form-element-horizontal">
                    <label>End Date</label>
                    <DateInput 
                        name="endDate"
                        value={this.state.endDate} 
                        onChange={this.updateValue} 
                    />
                </div>
                <div className="form-element-horizontal">
                    <label>End Time</label>
                    <TimeInput name="endTime" value={this.state.endTime} onChange={this.updateValue} nonMilitary={true} />
                </div>
                {
                    this.state.errors.length
                    ?  <div>
                        {
                            this.state.errors.map((e, index) => {
                                return (
                                    <div key={index} style={{
                                        margin: "0.25rem",
                                        padding: "0.25rem",
                                        color: "#ee4444",
                                        fontWeight: "600"
                                    }}>{e}</div>
                                );
                            })
                        }
                    </div>
                    : <></>
                }
                <div className="option  " onClick={this.submitLaneChange}>
                {
                    this.state.isEdit
                    ? "Update Lane Change"
                    : "Add Lane Change"
                }
                </div>
            </div>
        )
    }
}